import { get, writable } from 'svelte/store';

import { currentBuilding, currentRoom, options } from "./RoomStore";


/// SIMPLE ROUTING
function router(defaultRoute) {
	/// CALLABLE FUNCTIONS FOR WRITABLE STORE
	const { subscribe, set, update } = writable(defaultRoute);

	/// HOLD ROUTE LIST
	let routeHistory = [];

	/// RETURN NEW STORE OBJECT
	return {
		subscribe,
		/// OVERWRITE STORE FUNCTION WITH CUSTOM FUNCTIONALITY
		set: (r) => {
			/// SEARCH IS DEFAULT ROUTE --> USE IF NO ROUTE PROVIDED
			if (!r) {
				r = 'search';
			}
			if (r != routeHistory[routeHistory.length - 1]) {
				/// ADD ROUTE TO HISTORY
				routeHistory.push(r);
				/// UPDATE CURRENT ROUTE
				set(r);
				/// UDPATE THE URL
				updateURL(r);
			}
		},
		/// ADD NEW CUSTOM FUNCTIONALITY TO THE STORE
		back: () => {
			/// GET PREVIOUS ROUTE FROM HISTORY ARRAY
			/// -2, AS LOGIC ORDER WAS CHANGED FOR URL MANIPLUATION --> -1 IS CURRENT ROUTE
			let route = routeHistory[routeHistory.length - 2];
			/// SEARCH IS DEFAULT ROUTE --> USE IF NO PREVIOUS ROUTE AVAILABLE
			if (!route) {
				route = 'search';
			}
			/// REMOVE CURRENT ROUTE FROM HISTORY
			routeHistory.pop();
			/// UPDATE CURRENT ROUTE TO PREVIOUS ROUTE
			set(route);
			/// UPDATE THE URL
			updateURL(route);
		},
		length: () => {
			return routeHistory.length;
		},
		last: () => {
			return routeHistory[routeHistory.length - 1];
		},
	};

	function updateURL(r) {
		const params = new URLSearchParams(window.location.search);
		const prevParams = params.toString();

		const prevRoute = routeHistory[routeHistory.length - 1];

		if (r == 'roomdetails') {
			params.set('unitId', get(currentRoom).roomId);
		} else if (prevRoute == 'roomdetails') {
			params.delete('unitId');
		} else if (r == 'buildingdetails') {
			params.set('buildingId', get(currentBuilding).buildingId);
		} else if (prevRoute == 'buildingdetails') {
			params.delete('buildingId');
		}

		let paramString = params.toString();

		paramString = paramString.length ? '?' + paramString : paramString;

		if (r == 'search') {
			history.replaceState({ route: r }, '', `${window.location.origin}${window.location.pathname}${paramString}`);
		} else {
			history.pushState({ route: r }, '', `${window.location.origin}${window.location.pathname}${paramString}`);
		}
	}

}

export const route = router();

export const _loading = writable(false);